import { useQuery } from "@tanstack/react-query"

import { useAo } from "./ao"
import { getDataSource } from "../services/data-source"

export type PoolLiquidity = {
  amm_base_token: string
  amm_token0: string
  amm_quote_token: string
  amm_name: string
  amm_process: string
  reserves_0: string
  reserves_1: string
  pool_fee_bps: number
  amm_status: string
  amm_discovered_at_ts: number
  amm_token1: string
  token_0_decimals: number
  token_1_decimals: number
}

export type LiquidityTable = Record<string, PoolLiquidityResponse>
export type PoolLiquidityResponse = {
  Token_1_Denominator: string
  Token_0_Denominator: string
  Registered: string
  Token_0: string
  Token_1: string
  Updated_At: number
  Reserves_0: string
  Reserves_1: string
}

export function useGlobalLiquidity() {
  const ao = useAo()
  const dataSource = getDataSource(ao)

  return useQuery({
    queryKey: ["global-liquidity"],
    queryFn: async () => {
      try {
        const pools = await dataSource.getGlobalLiquidity()
        return pools
      } catch (error) {
        console.error("onGlobalLiquidityError", error)
        throw error
      }
    },
  })
}
